// import React, { useEffect, useState, useRef, useCallback } from "react";
// import { useParams, useNavigate, Link } from "react-router-dom";
// import axios from "axios";
// import { useCart } from "../contexts/CartContext";
// import { useAuth } from "../contexts/AuthContext";
// import "./product-details.css";

// const PRODUCT_API = process.env.REACT_APP_PRODUCT_SERVICE_URL;
// const REVIEWS_API = process.env.REACT_APP_PRODUCT_SERVICE_URL;
// const INVENTORY_API_BASE = process.env.REACT_APP_INVENTORY_SERVICE_URL;

// export default function ProductDetail() {
//   const { slug } = useParams();

//   // extract ID from slug
//   const productId = slug.split("-").pop();

//   const navigate = useNavigate();
//   const { auth, isAuthenticated } = useAuth();
//   const { cart, addToCart, isInCart } = useCart();

//   const [product, setProduct] = useState(null);
//   const [related, setRelated] = useState([]);
//   const [quantity, setQuantity] = useState(1);
//   const [selectedImage, setSelectedImage] = useState("");
//   const [reviews, setReviews] = useState([]);
//   const [newReview, setNewReview] = useState({
//     rating: 5,
//     comment: "",
//     images: [],
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [copied, setCopied] = useState(false);
//   const [zoomLevel, setZoomLevel] = useState(2);
//   const imgRef = useRef(null);
//   const zoomRef = useRef(null);
//   const [lensVisible, setLensVisible] = useState(false);
//   const [lensPos, setLensPos] = useState({ x: 0, y: 0 });
//   const [bgPos, setBgPos] = useState("0% 0%");

//   // const getImageUrl = (imgMeta) =>
//   //   imgMeta
//   //     ? `https://auth.afrogebeya.com/uploads/products/${imgMeta.storedName.replace(
//   //         /\\/g,
//   //         "/",
//   //       )}`
//   //     : "https://via.placeholder.com/400";

//   const getImageUrl = (imgMeta) =>
//     imgMeta
//       ? `https://afrogebeya.com/uploads/products/${imgMeta.replace(/\\/g, "/")}`
//       : "https://via.placeholder.com/400";
//   /* ---------------- FETCH PRODUCT ---------------- */
//   useEffect(() => {
//     let mounted = true;
//     const fetchProduct = async () => {
//       try {
//         const res = await axios.get(`${PRODUCT_API}/products/${productId}`);
//         if (!mounted) return;
//         const prod = res.data;

//         setProduct(prod);
//         setSelectedImage(getImageUrl(prod.mainImageUrl || prod.imageUrls?.[0]));

//         // related products
//         if (prod.categoryId) {
//           const relatedRes = await axios.get(`${PRODUCT_API}/products`, {
//             params: { categoryId: prod.categoryId, page: 0, size: 8 },
//           });
//           if (!mounted) return;
//           setRelated(
//             relatedRes.data.content.filter(
//               (p) => p.productId !== prod.productId,
//             ),
//           );
//         }
//       } catch (err) {
//         console.error("Failed to fetch product.");
//       }
//     };
//     fetchProduct();
//     return () => (mounted = false);
//   }, [productId]);

//   useEffect(() => {
//     // Scroll to top whenever productId changes
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, [productId]);

//   /* ---------------- FETCH REVIEWS ---------------- */
//   const fetchReviews = useCallback(async () => {
//     try {
//       const res = await axios.get(`${REVIEWS_API}/products/${productId}`);
//       const data = Array.isArray(res.data) ? res.data : [];
//       setReviews(data);
//     } catch (err) {
//       console.error("Failed to fetch reviews.");
//     }
//   }, [productId]);

//   /* ---------------- CART LOGIC ---------------- */

//   const getDefaultVariant = (product) => {
//     return (
//       product?.variants?.find((v) => v.isDefault) ||
//       product?.variants?.[0] ||
//       null
//     );
//   };
//   const selectedVariant = getDefaultVariant(product);

//   const cartItem = cart.find((item) => item.variantId === selectedVariant?.id);

//   const maxReached =
//     cartItem && selectedVariant?.availableQuantity != null
//       ? cartItem.quantity >= selectedVariant.availableQuantity
//       : false;

//   const handleQuantityChange = (e) => {
//     let val = parseInt(e.target.value, 10);
//     if (isNaN(val) || val < 1) val = 1;

//     const remaining =
//       (selectedVariant?.availableQuantity || 1) - (cartItem?.quantity || 0);
//   };

//   const handleAddToCart = () => {
//     if (!product || !selectedVariant) return;

//     addToCart(product, quantity);
//     setQuantity(1);
//   };

//   useEffect(() => {
//     const img = imgRef.current;
//     if (!img) return;

//     const handleWheel = (e) => {
//       if (!e.ctrlKey) return;
//       e.preventDefault();

//       setZoomLevel((prev) => {
//         let next = prev + (e.deltaY < 0 ? 0.2 : -0.2);
//         return Math.min(Math.max(next, 1.5), 4);
//       });
//     };

//     img.addEventListener("wheel", handleWheel, { passive: false });

//     return () => {
//       img.removeEventListener("wheel", handleWheel);
//     };
//   }, []);

//   /* ---------------- ZOOM & LENS ---------------- */
//   const handleMouseMove = (e) => {
//     const rect = imgRef.current.getBoundingClientRect();
//     const x = e.clientX - rect.left;
//     const y = e.clientY - rect.top;
//     const xPercent = (x / rect.width) * 100;
//     const yPercent = (y / rect.height) * 100;
//     setLensPos({ x, y });
//     setBgPos(`${xPercent}% ${yPercent}%`);
//     if (zoomRef.current) {
//       zoomRef.current.style.backgroundSize = `${zoomLevel * 100}%`;
//       zoomRef.current.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
//     }
//   };

//   const handleTouchMove = (e) => {
//     if (e.touches.length === 2) {
//       setZoomLevel((prev) => Math.min(prev + 0.05, 4));
//     }
//   };

//   const handleWheel = (e) => {
//     e.preventDefault();

//     setZoomLevel((prev) => {
//       let next = prev + (e.deltaY < 0 ? 0.2 : -0.2);
//       return Math.min(Math.max(next, 1.5), 4);
//     });
//   };

//   /* ---------------- REVIEW SUBMISSION ---------------- */
//   const handleReviewSubmit = async (e) => {
//     e.preventDefault();
//     if (!isAuthenticated) return alert("Login required.");
//     setSubmitting(true);
//     try {
//       const formData = new FormData();
//       formData.append("productId", productId);
//       formData.append("rating", newReview.rating);
//       formData.append("comment", newReview.comment);
//       newReview.images.forEach((file) => formData.append("images", file));

//       await axios.post(`${REVIEWS_API}`, formData, {
//         headers: {
//           Authorization: `Bearer ${auth.token}`,
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       setNewReview({ rating: 5, comment: "", images: [] });
//       fetchReviews();
//     } catch (err) {
//       console.error(err);
//       alert("Failed to submit review.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   /* ---------------- RATING SUMMARY ---------------- */
//   const ratingCounts = [5, 4, 3, 2, 1].map(
//     (star) => reviews.filter((r) => r.rating === star).length,
//   );
//   const averageRating =
//     reviews.length > 0
//       ? reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length
//       : 0;

//   if (!product)
//     return (
//       <div className="placeholder-glow">
//         <span className="placeholder col-12"></span>
//       </div>
//     );

//   const formattedPrice = new Intl.NumberFormat("en-US", {
//     style: "currency",
//     currency: product.currency || "USD",
//   }).format(product.price || 0);

//   const promoPrice = product.price + 0.1 * product.price;
//   const isSeller = auth?.roles?.includes("SELLER");

//   const shareUrl = `https://afrogebeya.com/products/preview/${slug}`;
//   const encodedUrl = encodeURIComponent(shareUrl);
//   const encodedText = encodeURIComponent(product?.productName || "");

//   const whatsappShare = `https://wa.me/?text=${encodedText}%20${encodedUrl}`;
//   const telegramShare = `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`;
//   const facebookShare = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;

//   const handleCopy = async () => {
//     try {
//       await navigator.clipboard.writeText(shareUrl);
//       setCopied(true);

//       setTimeout(() => setCopied(false), 2000);
//     } catch (err) {
//       console.error("Copy failed", err);
//     }
//   };

//   const handleShare = async () => {
//     if (!product) return;

//     try {
//       if (navigator.share) {
//         await navigator.share({
//           title: product.productName,
//           text: product.description?.slice(0, 100),
//           url: shareUrl,
//         });
//       } else {
//         await navigator.clipboard.writeText(shareUrl);
//         alert("Product link copied!");
//       }
//     } catch (err) {
//       console.error("Share failed:", err);
//     }
//   };

//   return (
//     <>
//       <div className="container py-4">
//         <nav aria-label="breadcrumb">
//           <ol className="breadcrumb mb-3 small">
//             <li className="breadcrumb-item">
//               <Link to="/" className="text-decoration-none">
//                 <i className="bi bi-house-door me-1"></i>
//                 Home
//               </Link>
//             </li>

//             <li className="breadcrumb-item">
//               <Link
//                 to={`/category/${product.categoryId}`}
//                 className="text-decoration-none"
//               >
//                 {product.categoryName}
//               </Link>
//             </li>

//             <li className="breadcrumb-item active fw-semibold text-dark">
//               {product.productName}
//             </li>
//           </ol>
//         </nav>

//         <div
//           className="row g-4 position-relative"
//           style={{ overflow: "visible" }}
//         >
//           <div className="col-lg-6 d-flex flex-column flex-md-row gap-3">
//             {/* MAIN IMAGE */}
//             <div
//               className="position-relative flex-grow-1 text-center order-1 order-md-2"
//               style={{ overflow: "visible", zIndex: 20 }}
//             >
//               <img
//                 loading="lazy"
//                 ref={imgRef}
//                 src={selectedImage}
//                 alt={product.productName}
//                 onTouchMove={handleTouchMove}
//                 className="img-fluid rounded border shadow-sm"
//                 style={{
//                   maxHeight: 500,
//                   objectFit: "contain",
//                   width: "100%",
//                   background: "#fff",
//                 }}
//                 onMouseEnter={() =>
//                   window.innerWidth > 768 && setLensVisible(true)
//                 }
//                 onMouseLeave={() => setLensVisible(false)}
//                 onMouseMove={(e) =>
//                   window.innerWidth > 768 && handleMouseMove(e)
//                 }
//               />

//               {lensVisible && (
//                 <>
//                   <div
//                     className="lens-rect"
//                     style={{
//                       left: lensPos.x - 75,
//                       top: lensPos.y - 50,
//                       backgroundImage: `url(${selectedImage})`,
//                       backgroundPosition: bgPos,
//                     }}
//                   />
//                   <div
//                     ref={zoomRef}
//                     className="zoom-box"
//                     style={{ backgroundImage: `url(${selectedImage})` }}
//                   />
//                 </>
//               )}
//             </div>

//             {/* THUMBNAILS */}
//             <div
//               className="d-flex flex-row flex-md-column gap-2 overflow-auto order-2 order-md-1"
//               style={{ maxWidth: "100%" }}
//             >
//               {product.mainImage && (
//                 <img
//                   src={getImageUrl(product.mainImageUrl)}
//                   alt="thumb"
//                   className={`img-thumbnail ${
//                     selectedImage === getImageUrl(product.mainImageUrl)
//                       ? "border-primary shadow"
//                       : "border"
//                   }`}
//                   style={{
//                     width: 80,
//                     height: 80,
//                     objectFit: "cover",
//                     flexShrink: 0,
//                   }}
//                   onClick={() =>
//                     setSelectedImage(getImageUrl(product.mainImageUrl))
//                   }
//                 />
//               )}

//               {product.imageUrls?.map((img, idx) => (
//                 <img
//                   key={idx}
//                   src={getImageUrl(img)}
//                   alt={`thumb-${idx}`}
//                   className={`img-thumbnail ${
//                     selectedImage === getImageUrl(img) ? "border-primary" : ""
//                   }`}
//                   style={{
//                     width: 80,
//                     height: 80,
//                     objectFit: "cover",
//                     flexShrink: 0,
//                   }}
//                   onClick={() => setSelectedImage(getImageUrl(img))}
//                 />
//               ))}
//             </div>
//           </div>

//           <div className="col-lg-6" style={{ position: "relative", zIndex: 1 }}>
//             <div className="sticky-top" style={{ top: 20 }}>
//               {/* <h2 className="fw-bold mb-2">{product.productName}</h2> */}
//               <div className="d-flex justify-content-between align-items-start mb-2 flex-wrap gap-2">
//                 <h2 className="fw-bold mb-0">{product.productName}</h2>

//                 <div className="d-flex gap-2 flex-wrap">
//                   {/* Native Share */}
//                   <button
//                     className="btn btn-light border"
//                     onClick={handleShare}
//                     title="Share"
//                   >
//                     <i className="bi bi-share"></i>
//                   </button>

//                   {/* WhatsApp */}
//                   <a
//                     href={whatsappShare}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="btn btn-success"
//                     title="Share on WhatsApp"
//                   >
//                     <i className="bi bi-whatsapp"></i>
//                   </a>

//                   {/* Telegram */}
//                   <a
//                     href={telegramShare}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="btn btn-primary"
//                     title="Share on Telegram"
//                   >
//                     <i className="bi bi-telegram"></i>
//                   </a>

//                   {/* Facebook */}
//                   <a
//                     href={facebookShare}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="btn btn-primary"
//                     title="Share on Facebook"
//                   >
//                     <i className="bi bi-facebook"></i>
//                   </a>

//                   {/* Copy Link */}
//                   <button
//                     className={`btn ${copied ? "btn-success" : "btn-outline-secondary"}`}
//                     onClick={handleCopy}
//                     title="Copy link"
//                   >
//                     {copied ? (
//                       <>
//                         <i className="bi bi-check-lg"></i> Copied
//                       </>
//                     ) : (
//                       <>
//                         <i className="bi bi-link-45deg"></i> Copy Link
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </div>
//               <p className="text-muted">{product.description}</p>

//               {/* Rating Display */}
//               <div className="d-flex align-items-center gap-2 mb-2">
//                 <span className="text-warning fs-5">
//                   {"★".repeat(Math.round(averageRating))}
//                   {"☆".repeat(5 - Math.round(averageRating))}
//                 </span>
//                 <small className="text-muted">({reviews.length} reviews)</small>
//               </div>

//               {/* Price Block */}
//               <div className="mb-3">
//                 <div className="fs-3 fw-bold ">{formattedPrice}</div>
//                 {product.discountPrice !== 0 && (
//                   <div className="text-muted text-decoration-line-through">
//                     {/* {product.price} */}
//                     {promoPrice}
//                   </div>
//                 )}
//                 <div className="text-muted text-danger">FREE DELIVERY</div>
//               </div>

//               {/* Stock Indicator */}
//               <div className="mb-3">
//                 {selectedVariant?.availableQuantity > 0 ? (
//                   <span className="badge bg-success-subtle text-success">
//                     In Stock ({selectedVariant.availableQuantity})
//                   </span>
//                 ) : (
//                   <span className="badge bg-danger-subtle text-danger">
//                     Out of Stock
//                   </span>
//                 )}
//               </div>

//               {/* Quantity*/}
//               <div className="card border-0 shadow-sm p-3 mb-3">
//                 <div className="mb-2">Quantity</div>
//                 <input
//                   type="number"
//                   min="1"
//                   max={selectedVariant?.availableQuantity ?? 1}
//                   value={quantity}
//                   onChange={handleQuantityChange}
//                   className="form-control mb-3"
//                 />

//                 <button
//                   className="btn btn-warning w-100 mb-2 fw-semibold"
//                   onClick={handleAddToCart}
//                   disabled={!selectedVariant?.availableQuantity}
//                 >
//                   🛒{" "}
//                   {maxReached
//                     ? "Max in Cart"
//                     : isInCart(selectedVariant?.id)
//                       ? "Add More"
//                       : "Add to Cart"}
//                 </button>

//                 <button
//                   className="btn btn-dark w-100 fw-semibold"
//                   disabled={!selectedVariant?.availableQuantity}
//                   onClick={() => navigate("/cart")}
//                 >
//                   Buy Now
//                 </button>
//               </div>

//               {/* Trust Badges */}
//               <div className="small text-muted">
//                 ✓ Secure Payment
//                 <br />
//                 ✓ 7 Days Return Policy
//                 <br />✓ Verified Seller
//               </div>
//             </div>
//           </div>

//           <hr className="my-5" />

//           <div className="row">
//             <div className="col-lg-8">
//               <h4 className="mb-3">Product Description</h4>
//               <p className="text-muted">{product.description}</p>

//               <h5 className="mt-4">Specifications</h5>
//               <table className="table table-sm">
//                 <tbody>
//                   <tr>
//                     <th>Brand</th>
//                     <td>{product.brand || "N/A"}</td>
//                   </tr>
//                   <tr>
//                     <th>Model</th>
//                     <td>{product.modelNumber || "N/A"}</td>
//                   </tr>
//                   <tr>
//                     <th>SKU</th>
//                     <td>{product.sku}</td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>

//         {/* Rating Summary */}
//         <div className="mt-5">
//           <div className="card border-0 shadow-sm p-4">
//             <h4 className="mb-3">Customer Reviews</h4>

//             <div className="d-flex align-items-center gap-3 mb-3">
//               <div className="display-5 fw-bold">
//                 {averageRating.toFixed(1)}
//               </div>
//               <div>
//                 <div className="text-warning fs-4">
//                   {"★".repeat(Math.round(averageRating))}
//                   {"☆".repeat(5 - Math.round(averageRating))}
//                 </div>
//                 <small className="text-muted">
//                   Based on {reviews.length} reviews
//                 </small>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Reviews Section */}
//         <div className="mt-5">
//           <h5>Reviews ({reviews.length})</h5>
//           {reviews.map((r) => (
//             <div key={r.id} className="card border-0 shadow-sm mb-3">
//               <div className="card-body">
//                 <div className="d-flex justify-content-between">
//                   <strong>{r.email}</strong>
//                   <small className="text-muted">
//                     {new Date(r.createdAt).toLocaleDateString()}
//                   </small>
//                 </div>

//                 <div className="text-warning mb-2">
//                   {"★".repeat(r.rating)}
//                   {"☆".repeat(5 - r.rating)}
//                 </div>

//                 <p className="mb-2">{r.comment}</p>

//                 {r.images?.length > 0 && (
//                   <div className="d-flex gap-2">
//                     {r.images.map((img) => (
//                       <img
//                         key={img.id}
//                         src={`https://auth.afrogebeya.com/uploads/products/${img.storedName}`}
//                         style={{
//                           width: 70,
//                           height: 70,
//                           objectFit: "cover",
//                           borderRadius: 8,
//                         }}
//                       />
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// }

import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { useCart } from "../contexts/CartContext";
import { useAuth } from "../contexts/AuthContext";
import "./product-details.css";

const PRODUCT_API = process.env.REACT_APP_PRODUCT_SERVICE_URL;

/* ─────────────────────────────────────────
   Helpers
───────────────────────────────────────── */
const getImageUrl = (storedName) =>
  storedName
    ? `https://afrogebeya.com/uploads/products/${String(storedName).replace(/\\/g, "/")}`
    : null;

const PLACEHOLDER = "https://via.placeholder.com/400x400?text=No+Image";

const formatCurrency = (amount, currency = "ETB") =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(amount || 0);

const Stars = ({ rating, size = 14 }) => {
  const full = Math.round(rating);
  const empty = 5 - full;
  return (
    <span style={{ fontSize: size, color: "#F59E0B", letterSpacing: 1 }}>
      {"★".repeat(full)}
      {"☆".repeat(empty)}
    </span>
  );
};

const SkeletonBlock = ({ h = 20, w = "100%", mb = 0 }) => (
  <span
    className="pd-skeleton pd-skeleton-block"
    style={{ height: h, width: w, marginBottom: mb, display: "block" }}
  />
);

/* ─────────────────────────────────────────
   Loading skeleton for the full page
───────────────────────────────────────── */
const PageSkeleton = () => (
  <div className="pd-container">
    <div className="pd-main">
      <div>
        <SkeletonBlock h={480} mb={12} />
        <div style={{ display: "flex", gap: 8 }}>
          {[...Array(4)].map((_, i) => (
            <SkeletonBlock key={i} h={72} w={72} />
          ))}
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <SkeletonBlock h={32} w="80%" />
        <SkeletonBlock h={20} w="40%" />
        <SkeletonBlock h={64} />
        <SkeletonBlock h={120} />
        <SkeletonBlock h={160} />
      </div>
    </div>
  </div>
);

/* ─────────────────────────────────────────
   Main component
───────────────────────────────────────── */
export default function ProductDetail() {
  const { slug } = useParams();
  const productId = slug?.split("-").pop();
  const navigate = useNavigate();
  const { auth } = useAuth();
  const { cart, addToCart, isInCart } = useCart();

  /* ── Data state ── */
  const [product, setProduct] = useState(null);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  /* ── UI state ── */
  const [selectedAttrs, setSelectedAttrs] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [activeTab, setActiveTab] = useState("description");
  const [copied, setCopied] = useState(false);
  const [lensVisible, setLensVisible] = useState(false);
  const [lensPos, setLensPos] = useState({ x: 0, y: 0 });
  const [zoomStyle, setZoomStyle] = useState({});
  const [zoomLevel, setZoomLevel] = useState(2.5);

  const imgRef = useRef(null);
  const zoomRef = useRef(null);

  /* ─────────────────────────────────────────
     Derived: variant selection
  ───────────────────────────────────────── */
  const variantAttrKeys = useMemo(() => {
    const keys = new Set();
    (product?.variants || []).forEach((v) =>
      Object.keys(v.attributes || {}).forEach((k) => keys.add(k)),
    );
    return [...keys];
  }, [product]);

  const attrOptionsMap = useMemo(() => {
    const map = {};
    variantAttrKeys.forEach((key) => {
      map[key] = [
        ...new Set(
          (product?.variants || [])
            .map((v) => v.attributes?.[key])
            .filter(Boolean),
        ),
      ];
    });
    return map;
  }, [product, variantAttrKeys]);

  /* Find variant matching all selected attrs */
  const selectedVariant = useMemo(() => {
    if (!product?.variants?.length) return null;

    const matched = product.variants.find((v) =>
      variantAttrKeys.every(
        (key) =>
          !selectedAttrs[key] || v.attributes?.[key] === selectedAttrs[key],
      ),
    );
    return (
      matched ||
      product.variants.find((v) => v.isDefault) ||
      product.variants[0]
    );
  }, [product, selectedAttrs, variantAttrKeys]);

  /* Is this attr value available given other current selections? */
  const isValueAvailable = useCallback(
    (key, value) =>
      (product?.variants || []).some((v) => {
        const othersMatch = Object.entries(selectedAttrs)
          .filter(([k]) => k !== key)
          .every(([k, val]) => v.attributes?.[k] === val);
        return othersMatch && v.attributes?.[key] === value;
      }),
    [product, selectedAttrs],
  );

  /* ─────────────────────────────────────────
     Derived: images for current selection
  ───────────────────────────────────────── */
  // const currentImages = useMemo(() => {
  //   const variantImgs = (selectedVariant?.imageUrls || []).filter(Boolean);
  //   const productImgs = (product?.imageUrls || []).filter(Boolean);
  //   const main = selectedVariant?.mainImage || product?.mainImage;
  //   const pool = variantImgs.length ? variantImgs : productImgs;
  //   if (main && !pool.includes(main)) return [main, ...pool];
  //   return pool.length ? pool : [null];
  // }, [selectedVariant, product]);

  const currentImages = useMemo(() => {
    const variantImgs = (selectedVariant?.imageUrls || []).filter(Boolean);
    const productImgs = (product?.imageUrls || []).filter(Boolean);

    const main = selectedVariant?.mainImage || product?.mainImage;

    // Merge all images
    const merged = [...variantImgs, ...productImgs];

    // Remove duplicates
    const unique = [...new Set(merged)];

    // Ensure main image is first
    if (main) {
      return [main, ...unique.filter((img) => img !== main)];
    }

    return unique.length ? unique : [null];
  }, [selectedVariant, product]);

  /* ─────────────────────────────────────────
     Fetch product
  ───────────────────────────────────────── */
  useEffect(() => {
    if (!productId) return;
    let mounted = true;
    setLoading(true);
    setError(null);

    (async () => {
      try {
        const res = await axios.get(`${PRODUCT_API}/products/${productId}`);
        if (!mounted) return;
        const prod = res.data;
        setProduct(prod);

        // Init variant selection from default variant
        const def =
          prod.variants?.find((v) => v.isDefault) || prod.variants?.[0];
        if (def) setSelectedAttrs(def.attributes || {});

        // Init main image
        const mainImg = def?.mainImage || prod.mainImage;
        setSelectedImage(mainImg ? getImageUrl(mainImg) : PLACEHOLDER);

        // Related products
        if (prod.categoryId) {
          const relRes = await axios.get(`${PRODUCT_API}/products/buyers`, {
            params: { categoryId: prod.categoryId, page: 0, size: 8 },
          });
          if (!mounted) return;
          setRelated(
            (relRes.data.content || []).filter(
              (p) => p.productId !== prod.productId,
            ),
          );
        }
      } catch {
        if (mounted) setError("Failed to load product details.");
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    window.scrollTo({ top: 0, behavior: "smooth" });
    return () => {
      mounted = false;
    };
  }, [productId]);

  /* Update selected image when variant changes */
  useEffect(() => {
    if (currentImages[0]) {
      setSelectedImage(getImageUrl(currentImages[0]) || PLACEHOLDER);
    }
  }, [selectedVariant]);

  /* ─────────────────────────────────────────
     Cart
  ───────────────────────────────────────── */
  const cartItem = cart.find((i) => i.variantId === selectedVariant?.id);
  const maxQty = selectedVariant?.availableQuantity ?? 0;
  const maxReached =
    cartItem && maxQty > 0 ? cartItem.quantity >= maxQty : false;

  const handleAddToCart = () => {
    if (!product || !selectedVariant) return;
    addToCart(product, quantity, selectedVariant);
    setQuantity(1);
  };

  /* FIX: original never called setQuantity */
  const decQty = () => setQuantity((q) => Math.max(1, q - 1));
  const incQty = () =>
    setQuantity((q) => {
      const remaining = maxQty - (cartItem?.quantity || 0);
      return Math.min(q + 1, remaining > 0 ? remaining : q + 1);
    });

  /* ─────────────────────────────────────────
     Image zoom & lens
  ───────────────────────────────────────── */
  const handleMouseMove = useCallback(
    (e) => {
      const rect = imgRef.current?.getBoundingClientRect();
      if (!rect) return;
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const xPct = (x / rect.width) * 100;
      const yPct = (y / rect.height) * 100;
      setLensPos({ x: x - 60, y: y - 60 });
      setZoomStyle({
        backgroundSize: `${zoomLevel * 100}%`,
        backgroundPosition: `${xPct}% ${yPct}%`,
      });
    },
    [zoomLevel],
  );

  /* FIX: single wheel handler, not duplicated */
  useEffect(() => {
    const img = imgRef.current;
    if (!img) return;
    const handler = (e) => {
      if (!e.ctrlKey) return;
      e.preventDefault();
      setZoomLevel((prev) =>
        Math.min(Math.max(prev + (e.deltaY < 0 ? 0.2 : -0.2), 1.5), 4),
      );
    };
    img.addEventListener("wheel", handler, { passive: false });
    return () => img.removeEventListener("wheel", handler);
  }, []);

  /* ─────────────────────────────────────────
     Share
  ───────────────────────────────────────── */
  const shareUrl = `https://afrogebeya.com/products/${slug}`;
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedName = encodeURIComponent(product?.productName || "");

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch {
      /* noop */
    }
  };

  /* ─────────────────────────────────────────
     Pricing
  ───────────────────────────────────────── */
  const currentPrice = selectedVariant?.price ?? product?.price ?? 0;

  const discountPrice = selectedVariant?.discountPrice;

  const showDiscount =
    discountPrice != null &&
    Number(discountPrice) > 0 &&
    Number(discountPrice) < Number(currentPrice);

  const displayPrice = showDiscount ? discountPrice : currentPrice;

  const currency = selectedVariant?.currency || product?.currency || "ETB";

  const discountPct = showDiscount
    ? Math.round((1 - Number(discountPrice) / Number(currentPrice)) * 100)
    : 0;

  /* ─────────────────────────────────────────
     Stock label
  ───────────────────────────────────────── */
  const stockQty = Number(selectedVariant?.availableQuantity ?? 0);
  const stockLabel =
    stockQty <= 0
      ? { cls: "pd-stock--out", text: "Out of Stock" }
      : stockQty <= 5
        ? { cls: "pd-stock--low", text: `Only ${stockQty} left` }
        : { cls: "pd-stock--in", text: `In Stock (${stockQty})` };

  /* ─────────────────────────────────────────
     Seller initial
  ───────────────────────────────────────── */
  const sellerInitial = (product?.sellerName || "S")[0].toUpperCase();

  /* ─────────────────────────────────────────
     Tabs config
  ───────────────────────────────────────── */
  const TABS = [
    { id: "description", label: "Description" },
    { id: "specs", label: "Specifications" },
    { id: "reviews", label: "Reviews" },
  ];

  /* ─────────────────────────────────────────
     Render
  ───────────────────────────────────────── */
  if (loading)
    return (
      <div className="pd-page">
        <PageSkeleton />
      </div>
    );

  if (error || !product)
    return (
      <div
        className="pd-page pd-container"
        style={{ textAlign: "center", paddingTop: 80 }}
      >
        <p style={{ color: "#C0392B", marginBottom: 16 }}>
          {error || "Product not found."}
        </p>
        <button className="pd-submit-btn" onClick={() => navigate(-1)}>
          ← Go Back
        </button>
      </div>
    );

  return (
    <div className="pd-page">
      <div className="pd-container">
        {/* ── Breadcrumb ── */}
        <nav className="pd-breadcrumb" aria-label="breadcrumb">
          <Link to="/">Home</Link>
          <span className="pd-breadcrumb__sep">›</span>
          {product.categoryName && (
            <>
              <Link to={`/category/${product.categoryId}`}>
                {product.categoryName}
              </Link>
              <span className="pd-breadcrumb__sep">›</span>
            </>
          )}
          {product.subCategoryName && (
            <>
              <Link
                to={`/category/${product.categoryId}?sub=${product.subCategoryId}`}
              >
                {product.subCategoryName}
              </Link>
              <span className="pd-breadcrumb__sep">›</span>
            </>
          )}
          <span className="pd-breadcrumb__current">{product.productName}</span>
        </nav>

        {/* ══════════════════════════════════
            MAIN GRID
        ══════════════════════════════════ */}
        <div className="pd-main">
          {/* ── Left: Image gallery ── */}
          <div className="pd-gallery">
            {/* Thumbnails */}
            <div className="pd-gallery__thumbs">
              {currentImages.map((img, i) => {
                const url = img ? getImageUrl(img) : PLACEHOLDER;
                return (
                  <img
                    key={i}
                    src={url}
                    alt={`view-${i + 1}`}
                    className={`pd-gallery__thumb${selectedImage === url ? " pd-gallery__thumb--active" : ""}`}
                    onClick={() => setSelectedImage(url)}
                    onError={(e) => {
                      e.target.src = PLACEHOLDER;
                    }}
                  />
                );
              })}
            </div>

            {/* Main image */}
            <div
              className="pd-gallery__main-wrap"
              onMouseEnter={() =>
                window.innerWidth > 1024 && setLensVisible(true)
              }
              onMouseLeave={() => setLensVisible(false)}
              onMouseMove={(e) =>
                window.innerWidth > 1024 && handleMouseMove(e)
              }
            >
              <img
                ref={imgRef}
                src={selectedImage || PLACEHOLDER}
                alt={product.productName}
                className="pd-gallery__img"
                onError={(e) => {
                  e.target.src = PLACEHOLDER;
                }}
                loading="lazy"
              />

              {/* Lens */}
              {lensVisible && (
                <div
                  className="pd-gallery__lens"
                  style={{ left: lensPos.x, top: lensPos.y }}
                />
              )}

              {/* Zoom box — rendered outside the clipped container via absolute + overflow visible on parent */}
              {lensVisible && (
                <div
                  ref={zoomRef}
                  className="pd-gallery__zoom"
                  style={{
                    backgroundImage: `url(${selectedImage})`,
                    ...zoomStyle,
                  }}
                />
              )}
            </div>
          </div>

          {/* ── Right: Product info ── */}
          <div className="pd-info">
            {/* Name + meta + share */}
            <div className="pd-info__header">
              <h1 className="pd-info__name">{product.productName}</h1>

              <div className="pd-info__meta">
                {(product.averageRating > 0 || product.totalRatings > 0) && (
                  <div className="pd-rating">
                    <Stars rating={product.averageRating ?? 0} size={15} />
                    <span className="pd-rating__count">
                      {(product.averageRating ?? 0).toFixed(1)} (
                      {product.totalRatings ?? 0})
                    </span>
                  </div>
                )}

                {product.totalSold > 0 && (
                  <>
                    <div className="pd-meta-sep" />
                    <span className="pd-sold">
                      <span>{product.totalSold}</span> sold
                    </span>
                  </>
                )}

                {/* Share buttons */}
                <div className="pd-share">
                  <a
                    href={`https://wa.me/?text=${encodedName}%20${encodedUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pd-share__btn"
                    title="WhatsApp"
                    style={{ color: "#25D366" }}
                  >
                    <i className="bi bi-whatsapp" />
                  </a>
                  <a
                    href={`https://t.me/share/url?url=${encodedUrl}&text=${encodedName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pd-share__btn"
                    title="Telegram"
                    style={{ color: "#2AABEE" }}
                  >
                    <i className="bi bi-telegram" />
                  </a>
                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pd-share__btn"
                    title="Facebook"
                    style={{ color: "#1877F2" }}
                  >
                    <i className="bi bi-facebook" />
                  </a>
                  <button
                    className={`pd-share__btn${copied ? " pd-share__btn--copied" : ""}`}
                    onClick={handleCopy}
                    title={copied ? "Copied!" : "Copy link"}
                  >
                    <i
                      className={`bi bi-${copied ? "check-lg" : "link-45deg"}`}
                    />
                  </button>
                </div>
              </div>
            </div>

            {/* Price block */}
            <div className="pd-price">
              <span className="pd-price__current">
                {formatCurrency(displayPrice, currency)}
              </span>
              {showDiscount && (
                <>
                  <span className="pd-price__original">
                    {formatCurrency(currentPrice, currency)}
                  </span>
                  <span className="pd-price__badge">-{discountPct}%</span>
                </>
              )}
              <span className="pd-price__free">🚚 Free Delivery</span>
            </div>

            {/* Stock indicator */}
            <div>
              <span className={`pd-stock ${stockLabel.cls}`}>
                <span className="pd-stock__dot" />
                {stockLabel.text}
              </span>
            </div>

            {/* Variant selector */}
            {variantAttrKeys.length > 0 && (
              <div className="pd-variants">
                {variantAttrKeys.map((key) => {
                  const selectedVal = selectedAttrs[key];
                  const isColor =
                    key.toLowerCase().includes("color") ||
                    key.toLowerCase().includes("colour");
                  return (
                    <div key={key} className="pd-attr-group">
                      <div className="pd-attr-group__label">
                        {key}
                        {selectedVal && <span>{selectedVal}</span>}
                      </div>
                      <div className="pd-attr-chips">
                        {(attrOptionsMap[key] || []).map((val) => {
                          const available = isValueAvailable(key, val);
                          const active = selectedVal === val;
                          return (
                            <button
                              key={val}
                              className={[
                                "pd-chip",
                                isColor ? "pd-chip--color" : "",
                                active ? "pd-chip--active" : "",
                                !available ? "pd-chip--disabled" : "",
                              ]
                                .filter(Boolean)
                                .join(" ")}
                              title={val}
                              disabled={!available}
                              onClick={() => {
                                setSelectedAttrs((p) => ({ ...p, [key]: val }));
                                setQuantity(1);
                              }}
                            >
                              {isColor ? null : val}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Quantity + Add to Cart */}
            <div className="pd-cart-box">
              <div className="pd-qty-row">
                <span className="pd-qty-label">Qty</span>
                <div className="pd-qty-ctrl">
                  <button
                    className="pd-qty-ctrl__btn"
                    onClick={decQty}
                    disabled={quantity <= 1}
                  >
                    −
                  </button>
                  <input
                    type="number"
                    className="pd-qty-ctrl__val"
                    value={quantity}
                    min={1}
                    max={maxQty || 1}
                    readOnly
                  />
                  <button
                    className="pd-qty-ctrl__btn"
                    onClick={incQty}
                    disabled={maxReached || stockQty <= 0}
                  >
                    +
                  </button>
                </div>
              </div>

              <button
                className="pd-btn pd-btn--cart"
                onClick={handleAddToCart}
                disabled={stockQty <= 0}
              >
                🛒{" "}
                {maxReached
                  ? "Max Added"
                  : isInCart(selectedVariant?.id)
                    ? "Add More"
                    : "Add to Cart"}
              </button>

              <button
                className="pd-btn pd-btn--buy"
                disabled={stockQty <= 0}
                onClick={() => {
                  handleAddToCart();
                  navigate("/cart");
                }}
              >
                Buy Now
              </button>
            </div>

            {/* Seller card */}
            {product.sellerName && (
              <div className="pd-seller">
                <div className="pd-seller__avatar">{sellerInitial}</div>
                <div>
                  <div className="pd-seller__label">Sold by</div>
                  <div className="pd-seller__name">{product.sellerName}</div>
                </div>
              </div>
            )}

            {/* Trust badges */}
            <div className="pd-trust">
              {[
                "Secure & Verified Payment",
                `7-Day Return Policy${product.returnPolicy ? ` · ${product.returnPolicy}` : ""}`,
                product.warrantyPeriod
                  ? `${product.warrantyPeriod} Month Warranty`
                  : "Verified Seller",
              ].map((t) => (
                <div key={t} className="pd-trust__item">
                  <span className="pd-trust__icon">✓</span> {t}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════
            TABS
        ══════════════════════════════════ */}
        <div className="pd-tabs">
          <nav className="pd-tabs__nav">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                className={`pd-tabs__btn${activeTab === tab.id ? " pd-tabs__btn--active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </nav>

          <div className="pd-tabs__body">
            {/* Description */}
            {activeTab === "description" && (
              <div
                style={{
                  lineHeight: 1.8,
                  fontSize: 15,
                  color: "#374151",
                  maxWidth: 720,
                }}
              >
                {product.description || (
                  <span style={{ color: "#9CA3AF" }}>
                    No description provided.
                  </span>
                )}
              </div>
            )}

            {/* Specifications */}
            {activeTab === "specs" && (
              <table className="pd-specs">
                <tbody>
                  {[
                    ["Brand", product.brand || "—"],
                    ["Model", product.modelNumber || "—"],
                    ["SKU", product.sku || selectedVariant?.sku || "—"],
                    [
                      "Condition",
                      product.productCondition ||
                        selectedVariant?.productCondition ||
                        "—",
                    ],
                    ["Category", product.categoryName || "—"],
                    ["Subcategory", product.subCategoryName || "—"],
                    ["Currency", currency],
                    ...(product.weightUnit
                      ? [["Weight Unit", product.weightUnit]]
                      : []),
                    ...(product.dimensionUnit
                      ? [["Dimension Unit", product.dimensionUnit]]
                      : []),
                    ...(product.shippingClass
                      ? [["Shipping Class", product.shippingClass]]
                      : []),
                    /* Product-level attributes */
                    ...Object.entries(product.attributes || {}),
                    /* Selected variant attributes */
                    ...Object.entries(selectedVariant?.attributes || {}),
                  ].map(([key, val]) => (
                    <tr key={key}>
                      <th>{key}</th>
                      <td>{val}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* Reviews — endpoint not yet available */}
            {activeTab === "reviews" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "40px 24px",
                  gap: 12,
                  textAlign: "center",
                }}
              >
                <span style={{ fontSize: 36 }}>⭐</span>
                <p
                  style={{
                    margin: 0,
                    fontSize: 15,
                    fontWeight: 600,
                    color: "#0D1526",
                  }}
                >
                  Reviews coming soon
                </p>
                <p
                  style={{
                    margin: 0,
                    fontSize: 13,
                    color: "#6B7A99",
                    maxWidth: 320,
                  }}
                >
                  Customer reviews will be available here once the feature is
                  live.
                </p>
              </div>
            )}
          </div>
        </div>

        {/* ══════════════════════════════════
            RELATED PRODUCTS
        ══════════════════════════════════ */}
        {related.length > 0 && (
          <div className="pd-related">
            <h4>You May Also Like</h4>
            <div className="pd-related-grid">
              {related.slice(0, 8).map((p) => {
                const img = getImageUrl(p.mainImageUrl || p.mainImage);
                const relSlug = `${p.productName?.toLowerCase().replace(/\s+/g, "-")}-${p.productId}`;
                return (
                  <Link
                    key={p.productId}
                    to={`/products/${relSlug}`}
                    className="pd-related-card"
                  >
                    <img
                      src={img || PLACEHOLDER}
                      alt={p.productName}
                      onError={(e) => {
                        e.target.src = PLACEHOLDER;
                      }}
                      loading="lazy"
                    />
                    <div className="pd-related-card__body">
                      <div className="pd-related-card__name">
                        {p.productName}
                      </div>
                      <div className="pd-related-card__price">
                        {formatCurrency(p.price, p.currency)}
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
